/* eslint-disable no-unused-vars */
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader.js';
import _ from 'lodash';
import * as THREE from 'three';
const THREE_PATH = `https://unpkg.com/three@0.${THREE.REVISION}.x`
const MANAGER = new THREE.LoadingManager();
const DRACO_LOADER = new DRACOLoader(MANAGER).setDecoderPath(`${THREE_PATH}/examples/js/libs/draco/gltf/`);
const KTX2_LOADER = new KTX2Loader(MANAGER).setTranscoderPath(`${THREE_PATH}/examples/js/libs/basis/`);


export const loadGltf = (url, gl) => {
  return new Promise(async (resolve, reject) => {
    const loader = new GLTFLoader(MANAGER)
      .setCrossOrigin('anonymous')
      .setDRACOLoader(DRACO_LOADER)
      .setKTX2Loader(KTX2_LOADER.detectSupport(gl))
      .setMeshoptDecoder(MeshoptDecoder);
    try {
      let modelData = await loader.loadAsync(url,
        (p) => {
          // console.log(p);
        }).catch((err) => {
          console.log(err);
          resolve(null);
        });
      modelData.scene.traverse(function (node) {
        if (node.isMesh) {
          node.castShadow = true;
          node.receiveShadow = true;
          node.needsUpdate = true
          node.updateMatrixWorld()
        }
      })
      resolve(modelData)
    } catch (err) {
      console.log(err);
      reject()

    }
  });
}